import TravelCompanions from './components/TravelCompanions.css';

export default {
	TravelCompanions
};
